































import { Component, Prop, Vue } from 'vue-property-decorator';
import { AddressGoogleData } from '@/models/location';
import { VueMultiselectOptions } from '@/models/select-dropdown';
import SelectDropdownField, {
  SelectDropdownFieldVariant
} from '@/componentsV2/molecules/SelectDropdownField/SelectDropdownField.vue';
import SignUpService from '@/api/SingupService';
import SelectDropDownFieldUtils from '@/utils/selectDropdownFieldUtils';
import ArrowBack from '@/components/icons/Arrow.vue';

@Component({
  components: {
    SelectDropdownField,
    ArrowBack
  }
})
export default class GoogleAddressFieldDropdown extends Vue {
  @Prop({ default: false }) readonly error!: boolean;
  @Prop({ default: 'address' }) readonly name!: string;
  @Prop({ default: () => ({ value: '', label: '' }) })
  initialValue!: VueMultiselectOptions;
  @Prop({ default: 'normal' }) variant?: SelectDropdownFieldVariant;
  @Prop({ default: '' }) label?: string;
  @Prop({ default: '' }) helpText?: string;

  isLoading = false;
  adressSelected = null;
  addressOptions: Array<VueMultiselectOptions> = [];
  signUpService: SignUpService = new SignUpService();

  propertiesSelectdropdown = {
    ...SelectDropDownFieldUtils.getSelectdropdownPropertiesDefault(),
    name: this.name,
    translateKey: 'googleAddress',
    maxlengthInput: '100',
    showNoOptions: false
  };

  created() {
    if (this.initialValue.value && !this.addressOptions.length) {
      this.addressOptions = [{ ...this.initialValue }];
    }
  }

  getCountryCode() {
    return this.$store.getters['internationalization/getCountrySettings']
      .countryIso2;
  }

  async searchAddress(term: string) {
    if (!term) return;

    this.isLoading = true;

    this.$emit('search', term);

    try {
      const response = await this.signUpService.getGoogleAdresses(term);

      this.addressOptions = response.data.map((item: AddressGoogleData) => ({
        value: item.description,
        label: item.description,
        additionalInformation: item
      }));
    } finally {
      this.isLoading = false;
    }
  }

  triggerSelect(selectedOption: VueMultiselectOptions) {
    this.$emit('input', selectedOption.additionalInformation);
  }

  triggerClearAll() {
    this.addressOptions = [];
    this.$emit('triggerClearValue');
  }
}
